import styled from 'styled-components'

export const InfoParagraph = styled.p`
  font-weight: ${({
    theme: {
      font: { weights },
    },
  }) => weights.regular};

  margin-top: 0;
  margin-bottom: 0;
  word-break: break-word;
`
